<template>
  <div id="add_custom_field" class="modal fade" role="dialog">
    <div class="modal-dialog modal-width">
      <div class="modal-content text-center">
        <div id="data_sheet" class="modal-body mb-4">
          <div class="font-weight-bold">فیلد دلخواه</div>
        </div>
        <form @submit.prevent="addField" class="flex-column justify-content-center align-items-center px-4 mb-5">
          <div class="form-group my-2">
            <span
                class="d-flex align-items-center my-1 bg-white text-dark"
                id="basic-addon1"
            >نام فیلد
              <span class="text-danger">*</span>
            </span>
            <input
                type="text"
                class="form-control"
                id="fa_name"
                name="fa_name"
                aria-describedby="basic-addon1"
                v-model="fa_name"
            />
          </div>
          <div class="my-2 form-group">
            <span
                class="d-flex my-1 bg-white text-dark"
                id="basic-addon1"
            >نام انگلیسی فیلد
              <span class="text-danger">*</span>
            </span>
            <input
                type="text"
                class="form-control"
                id="name"
                name="name"
                aria-describedby="basic-addon1"
                v-model="name"
            />
          </div>
          <div class="my-2 form-group">
            <span
                class="d-flex align-items-center my-1 bg-white text-dark"
                id="basic-addon1"
            >نوع فیلد
              <span class="text-danger">*</span>
            </span>
            <select
                class="form-control kt-selectpicker"
                name="type"
                v-model="type"
            >
              <option
                  v-for="type in fieldTypes"
                  :key="type.value"
                  :value="type.value"
              >
                {{type.fa_name}}
              </option>
            </select>
          </div>
          <div
              class="form-group my-2"
              v-if="[
                  fieldTypesConstants.DATE,
                  fieldTypesConstants.SELECT,
              ].includes(type)"
          >
              <span
                  class="d-flex align-items-center my-1 bg-white text-dark"
                  id="basic-addon1"
              >
                مقدار پیش فرض
              </span>
            <input
                type="text"
                class="form-control"
                id="default_value"
                name="default_value"
                aria-describedby="basic-addon1"
                v-model="default_value.data"
            />
          </div>
          <div
            v-if="[
              fieldTypesConstants.STRING,
              fieldTypesConstants.NUMERIC,
              fieldTypesConstants.TEXT,
              fieldTypesConstants.DATE,
            ].includes(type)"
            class="form-group my-2"
          >
              <span
                  class="d-flex align-items-center my-1 bg-white text-dark"
                  id="basic-addon1"
              >
                مقدار placeholder
              </span>
            <input
                type="text"
                class="form-control"
                id="placeholder"
                name="placeholder"
                aria-describedby="basic-addon1"
                v-model="placeholder.data"
            />
          </div>
          <div
              v-if="type === fieldTypesConstants.SELECT"
              class="form-group my-2"
          >
            <span
                class="d-flex align-items-center my-1 bg-white text-dark"
                id="basic-addon1"
            >
              مقادیر لیست فیلد انتخابی
            </span>
            <div v-for="(option, index) in options.data" :key="index" class="d-flex align-items-center my-1">
              <input
                  name="options"
                  v-model="options.data[index]"
                  type="text"
                  class="form-control me-2"
                  :placeholder="'Option ' + (index + 1)"
              />
              <button
                  type="button"
                  class="btn btn-danger"
                  @click="removeOption(index)"
              >
                حذف
              </button>
            </div>

            <!-- Button to add a new option -->
            <button
                type="button"
                class="btn btn-success mt-2"
                @click="addOption"
            >
              افزودن گزینه جدید
            </button>
          </div>
          <div class="mt-4">
            <button id="submit-button" type="submit" class="btn btn-success">افزودن</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { fieldTypes, fieldTypesConstants } from '@/constants/CustomerFormatFieldType';
import $ from 'jquery'

export default {
  name: 'CreateFieldModal',
  data() {
    return {
        name: '',
        fa_name: '',
        type: null,
        default_value: {
          type: 'default_value',
          data: '',
        },
        placeholder: {
          type: 'placeholder',
          data: '',
        },
        options: {
          type: 'options',
          data: []
        },
        removable: true
    }
  },
  computed: {
    fieldTypes() {
      return fieldTypes
    },
    fieldTypesConstants() {
      return fieldTypesConstants
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  methods: {
    resetCustomField() {
      // Reset the data
        this.name = ''
        this.fa_name = ''
        this.type = null
        this.default_value = {
          type: 'default_value',
          data: '',
        }
        this.placeholder = {
          type: 'placeholder',
          data: '',
        }
        this.options = {
          type: 'options',
          data: []
        }
        this.removable = true
    },
    addOption() {
      this.options.data.push(""); // Adds an empty string for a new option
    },
    removeOption(index) {
      if (this.options.data.length > 1) {
        this.options.data.splice(index, 1); // Removes option at the specified index
      }
    },
    addField(e) {
      let form = $(e.target)
      let btn = $("#submit-button")

      form.validate({
        rules: {
          name: {
            required: true,
            minlength: 3
          },
          fa_name: {
            required: true,
            minlength: 3
          },
          type: {
            required: true,
          },
        }
      })

      if (this.type === fieldTypesConstants.SELECT && this.options.data.length < 2 ) {
        return this.toastr.error('برای فیلد انتخابی حداقل لیست انتخابی باید بیشتر از یک عدد باشد.')
      }

      if (!form.valid()) {
        return;
      }

      let details = []
      if (this.default_value.data)
        details.push(this.default_value)

      if (this.placeholder.data)
        details.push(this.placeholder)

      if (this.options.data.length > 0)
        details.push(this.options)

      let data = {
        name: this.name,
        fa_name: this.fa_name,
        type: this.type,
        details: details,
        removable: this.removable,
      }

      this.$emit('addField', data)
      this.resetCustomField()
    },
  },
};
</script>

<style scoped>

</style>